import axios from 'axios';

const API_KEY = process.env.VUE_APP_API_KEY;
const api = axios.create({
    baseURL: `${process.env.VUE_APP_URL_API}`,
    headers: {
        'x-api-key': API_KEY,
        'Content-Type': 'application/json',
    },
});

api.interceptors.request.use(
    (config) => {
        const user = JSON.parse(localStorage.getItem('userData'));

        if (user && user.token) {
            config.headers['Authorization'] = `Bearer ${user.token}`;
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default api;